import React, {useState, useEffect} from "react"
import {Link, useHistory, useLocation} from "react-router-dom"
import {AppBar, Avatar, Button, Toolbar, Typography, MenuItem} from "@material-ui/core"
import {Popper, Grow, Paper, ClickAwayListener, MenuList} from "@material-ui/core"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import {useDispatch} from "react-redux"
import decode from "jwt-decode"
import useStyles from "./styles"
import flux from "../../images/flux.png"
import text from "../../images/fluxText.png"
import * as actionType from "../../constants/actionTypes"

const Navbar = () => {
  const classes = useStyles()
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("profile")))
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  const logout = () => {
    dispatch({type: actionType.LOGOUT})

    handleClose()
    history.push("/auth")

    setUser(null)
  }

  useEffect(() => {
    const token = user?.token

    if (token) {
      const decodedToken = decode(token)

      if (decodedToken.exp * 1000 < new Date().getTime()) {
        logout()
      }
    }

    setUser(JSON.parse(localStorage.getItem("profile")))
  }, [location, user?.token])

  //Dropdown logic
  const [open, setOpen] = useState(false)
  const anchorRef = React.useRef(null)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event?.target)) {
      setOpen(false)
    }

    setOpen(false)
  }

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault()
      setOpen(false)
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open)
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus()
    }

    prevOpen.current = open
  }, [open])

  function handleCloseLogout() {
    handleClose()
    logout()
  }

  return (
    <AppBar className={classes.appBar} position='static' color='inherit'>
      <Link to='/' className={classes.brandContainer}>
        <img src={text} alt='icon' height='60' />
        <img className={classes.image} src={flux} alt='icon' height='60' />
      </Link>
      <Toolbar className={classes.toolbar}>
        {user?.result ? (
          <div className={classes.profile} ref={anchorRef} aria-controls={open ? "menu-list-grow" : undefined} aria-haspopup='true' onClick={handleToggle}>
            <Avatar className={classes.purple} alt={user?.result.name} src={user?.result.imageUrl}>
              {user?.result.name.charAt(0)}
            </Avatar>
            <Typography className={classes.userName} variant='h6'>
              {user?.result.name}
            </Typography>
            <ExpandMoreIcon />
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
              {({TransitionProps, placement}) => (
                <Grow {...TransitionProps} style={{transformOrigin: placement === "bottom" ? "center top" : "center bottom"}}>
                  <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                      <MenuList autoFocusItem={open} id='menu-list-grow' onKeyDown={handleListKeyDown}>
                        <MenuItem onClick={handleCloseLogout}>Logout</MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
            {/* <Button variant='contained' className={classes.logout} color='secondary' onClick={logout}>
              Logout
            </Button> */}
          </div>
        ) : (
          <Button component={Link} to='/auth' variant='contained' color='primary'>
            Sign In
          </Button>
        )}
      </Toolbar>
    </AppBar>
  )
}

export default Navbar
